import React, { createContext, useContext, useState, ReactNode } from 'react';

interface VoiceModeContextType {
  isVoiceModeActive: boolean;
  setIsVoiceModeActive: (active: boolean) => void;
}

const VoiceModeContext = createContext<VoiceModeContextType | undefined>(undefined);

export function VoiceModeProvider({ children }: { children: ReactNode }) {
  const [isVoiceModeActive, setIsVoiceModeActive] = useState(false);

  return (
    <VoiceModeContext.Provider value={{ isVoiceModeActive, setIsVoiceModeActive }}>
      {children}
    </VoiceModeContext.Provider>
  );
}

export function useVoiceMode() {
  const context = useContext(VoiceModeContext);
  if (context === undefined) {
    throw new Error('useVoiceMode must be used within a VoiceModeProvider');
  }
  return context;
}
